import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireJefe = false, requireJefeOrAdmin = false }) => {
  const { isAuthenticated, loading, isAdmin, hasRole, user } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return (
      <div className="error-container">
        <h2>Acceso Denegado</h2>
        <p>No tienes permisos para acceder a esta página.</p>
        <button 
          className="btn btn-primary"
          onClick={() => window.history.back()}
        >
          Volver
        </button>
      </div>
    );
  }

  if (requireJefe) {
    // Verificar explícitamente que el usuario existe y es JEFE
    if (!user || user.rol !== 'JEFE') {
      console.warn('⚠️ Intento de acceso no autorizado al dashboard. Rol del usuario:', user?.rol || 'No definido');
      return <Navigate to="/expedientes" replace />;
    }
  }

  if (requireJefeOrAdmin) {
    if (!user || !['JEFE', 'ADMIN'].includes(user.rol)) {
      return <Navigate to="/expedientes" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;








